/* eslint-disable no-nested-ternary */
import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  CheckCircleOutlineRounded,
  ContentCopyRounded,
  Refresh,
  SearchRounded,
} from '@mui/icons-material';
import {
  SwipeableDrawer,
  Paper,
  Table,
  TableBody,
  TableContainer,
  TablePagination,
  TableRow,
  TableHead,
  Avatar,
  Dialog,
  DialogContent,
  DialogTitle,
  TextField,
  CircularProgress,
  Box,
  DialogActions,
} from '@mui/material';
import { toast } from 'react-toastify';

import { stringAvatar } from '../../utils/avatarGenerator';
import { splitName } from '../../utils/nameHelpers';

import useAuthStore from '../../store/auth';
import useCompanyStore from '../../store/companies';

import alert from '../../assets/alert.svg';
import {
  Button,
  Filters,
  Container,
  Page,
  TableCell,
  Div,
  TableTitle,
  TextModal,
  TitleModal,
  TextModalSuccess,
} from './styles';

import { CriarMembro } from './CriarMembro';
import { InfoCard } from '../../components/InfoCard';

import {
  getCompanyByIdRequest,
  getUserInviteByUserIdRequest,
  resendInviteRequest,
  User,
} from '../../services/requests';

export function GestaoUsuarios() {
  const navigate = useNavigate();

  const selectedCompany = useCompanyStore(state => state.selectedCompany);
  const setSelectedCompany = useCompanyStore(state => state.setSelectedCompany);
  const user = useAuthStore(state => state.user);

  const [search, setSearch] = useState('');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [recoverPassword, setRecoverPassword] = useState(false);
  const [desactiveMember, setDesactiveMember] = useState(false);
  const [listagemUsuarios, setListagemUsuarios] = useState<Partial<User[]>>([]);
  const [openDrawerAddMember, setOpenDrawerAddMember] = useState(false);
  const [openDrawerSelected, setOpenDrawerSelected] = useState('');
  const [loading, setLoading] = useState(false);
  const [loadingReInvite, setLoadingReInvite] = useState(false);
  const [openModalToResendInvite, setOpenModalToResendInvite] = useState(false);
  const [openModalToSuccessInvite, setOpenModalToSuccessInvite] =
    useState(false);
  const [userData, setUserData] = useState({
    id: '',
    email: '',
    name: '',
    link: '',
  });
  const [userListRendered, setUserListRendered] = useState<Partial<User[]>>([]);
  const [totalPages, setTotalPages] = useState(0);

  const filteringUsers = listagemUsuarios?.filter(u =>
    u?.name.toUpperCase().includes(search.toUpperCase()),
  );
  const usersListFiltered =
    search.length > 0 ? filteringUsers : userListRendered;

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // const loadUsuarios = useCallback(async () => {
  //   setLoading(true);
  //   try {
  //     const response = await getUsersByCompanyIdRequest(
  //       selectedCompany?.id as string,
  //       search,
  //       page.toString(),
  //       rowsPerPage.toString(),
  //       '',
  //     );

  //     if (response?.status === 200) {
  //       setListagemUsuarios(response.data);
  //     } else {
  //       setListagemUsuarios([]);
  //     }
  //   } catch (error) {
  //     console.error('Error loadUsuarios', error);
  //   } finally {
  //     setLoading(false);
  //   }
  // }, [page, rowsPerPage, search, selectedCompany?.id]);

  // eslint-disable-next-line consistent-return
  // useEffect(() => {
  //   setLoading(true);
  //   if (selectedCompany) {
  //     const delayDebounceFn = setTimeout(() => {
  //       loadUsuarios();
  //     }, 1000);
  //     return () => clearTimeout(delayDebounceFn);
  //   }
  // }, [search, rowsPerPage, page]);

  const loadCompany = useCallback(async () => {
    try {
      const response = await getCompanyByIdRequest(
        selectedCompany?.id as string,
      );

      if (response?.status === 200) {
        setSelectedCompany(response?.data);
      }
    } catch (err) {
      console.log(err);
    }
  }, [selectedCompany?.id, setSelectedCompany]);

  useEffect(() => {
    loadCompany();
  }, []);

  const removeDuplicates = (users: User[]) => {
    const seenIds = new Set();

    const uniqueUsers = users?.filter((userFilt: User) => {
      if (userFilt?.id) {
        if (!seenIds.has(userFilt?.id)) {
          seenIds.add(userFilt?.id);
          return true;
        }
      }

      return false;
    });

    return uniqueUsers;
  };

  useEffect(() => {
    if (selectedCompany) {
      const usersFilteredByCompany = removeDuplicates(
        selectedCompany?.users as User[],
      );
      setListagemUsuarios(usersFilteredByCompany);
    }
  }, [listagemUsuarios, selectedCompany]);

  useEffect(() => {
    const startIndex = page * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;

    const usuariosExibidos = listagemUsuarios.slice(startIndex, endIndex);

    const totalPage = Math.ceil(listagemUsuarios.length / rowsPerPage);
    setTotalPages(totalPage);

    setUserListRendered([...usuariosExibidos]);
  }, [listagemUsuarios, selectedCompany, rowsPerPage, page]);

  const openDrawerMembers = () => {
    setOpenDrawerSelected('add');
    setOpenDrawerAddMember(true);
  };

  const handleCloseRecoverPassword = () => {
    setRecoverPassword(false);
  };

  const handleCloseMemberDesactive = () => {
    setDesactiveMember(false);
  };

  const defaultLabelDisplayedRows = ({ from, to, count }: any) => {
    return `${from}–${to} de ${count !== -1 ? count : `mais de ${to}`}`;
  };

  const handleOpenModal = useCallback(
    async (id: string, email: string, name: string) => {
      try {
        const response = await getUserInviteByUserIdRequest(
          id,
          selectedCompany?.account_id as string,
        );

        if (response?.status === 200) {
          setUserData({ id, email, name, link: response?.data });
          setOpenModalToResendInvite(true);
        }
      } catch (err) {
        console.log(err);
      }
    },
    [selectedCompany?.account_id],
  );

  const handleReInvite = useCallback(async () => {
    try {
      setLoadingReInvite(true);
      const response = await resendInviteRequest(
        userData.id,
        selectedCompany?.id as string,
      );

      if (response?.status === 200) {
        setOpenModalToResendInvite(false);
        setOpenModalToSuccessInvite(true);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoadingReInvite(false);
    }
  }, [selectedCompany?.id, userData]);

  const contentCopy = () => {
    if (userData?.link) {
      navigator?.clipboard
        ?.writeText(userData?.link)
        .then(() => {
          toast.success('Convite copiado para a área de transferência', {
            toastId: 1,
          });
        })
        .catch(error => {
          console.error('Erro ao copiar o texto:', error);
        });
    }
  };

  if (loading) {
    <Container>
      <CircularProgress />
    </Container>;
  }

  return (
    <Container>
      <React.Fragment key="right">
        <Filters>
          <div className="container-filters">
            <section className="section-filter">
              <TextField
                id="input-with-icon-adornment"
                placeholder="Buscar usuário"
                variant="standard"
                fullWidth
                value={search}
                onChange={ev => setSearch(ev.target.value)}
                sx={{
                  background: '#FFFFFF',
                  borderRadius: '4px',
                  padding: '9px 12px',
                  fontWeight: '400',
                  fontSize: '16px',
                  color: '#616161',
                }}
                InputProps={{
                  endAdornment: <SearchRounded sx={{ color: '#616161' }} />,
                  disableUnderline: true,
                }}
              />
              <Button
                variant="contained"
                className="btn-new-users"
                onClick={() => openDrawerMembers()}
                sx={{ whiteSpace: 'nowrap' }}
                disabled={user?.profile === 'UN3' || user?.profile === 'UN4'}
              >
                ADICIONAR USUÁRIO
              </Button>
            </section>

            <SwipeableDrawer
              className="drawer"
              anchor="right"
              open={openDrawerAddMember}
              onClose={() => setOpenDrawerAddMember(false)}
              onOpen={() => setOpenDrawerAddMember(true)}
              ModalProps={{
                keepMounted: true,
              }}
            >
              <CriarMembro
                setOpenDrawerAddMember={setOpenDrawerAddMember}
                openDrawerAddMember={openDrawerAddMember}
                listagemUsuarios={listagemUsuarios}
                setListagemUsuarios={setListagemUsuarios}
                loadCompany={loadCompany}
              />
            </SwipeableDrawer>
          </div>
        </Filters>

        {loading ? (
          <Page
            display="flex"
            paddingTop="250px"
            justifyContent="center"
            width="100%"
          >
            <CircularProgress />
          </Page>
        ) : (
          <Page>
            <div className="container-page">
              <Paper
                sx={{
                  width: '100%',
                  overflow: 'hidden',
                  boxShadow: 'none',
                }}
              >
                {usersListFiltered && usersListFiltered?.length > 0 ? (
                  <TableContainer
                    sx={{ background: '#FFFFFF', borderRadius: '6px' }}
                  >
                    <Table sx={{ minWidth: 750 }} aria-labelledby="tableTitle">
                      <TableHead
                        sx={{
                          color: '#000000',
                          fontWeight: '400',
                          fontSize: '20px',
                          margin: '20px 0 15px 24px',
                          display: 'table-caption',
                        }}
                      >
                        Usuários
                      </TableHead>
                      <TableHead>
                        <TableRow sx={{ width: 'fit-content' }}>
                          <TableCell
                            align="left"
                            //   padding={headCell.disablePadding ? 'none' : 'normal'}
                            //   key={headCell.id}
                            sx={{
                              alignSelf: 'center',
                              height: '48px',
                            }}
                          >
                            <TableTitle>NOME</TableTitle>
                          </TableCell>
                          <TableCell
                            align="left"
                            //   padding={headCell.disablePadding ? 'none' : 'normal'}
                            //   key={headCell.id}
                            sx={{
                              alignSelf: 'center',
                              height: '48px',
                              padding: '0px',
                            }}
                          >
                            <TableTitle>SOBRENOME</TableTitle>
                          </TableCell>
                          <TableCell
                            align="left"
                            //   padding={headCell.disablePadding ? 'none' : 'normal'}
                            //   key={headCell.id}
                            sx={{
                              alignSelf: 'center',
                              height: '48px',
                              padding: '0px',
                            }}
                          >
                            <TableTitle>E-MAIL</TableTitle>
                          </TableCell>
                          <TableCell
                            align="center"
                            //   padding={headCell.disablePadding ? 'none' : 'normal'}
                            //   key={headCell.id}
                            sx={{
                              alignSelf: 'center',
                              height: '48px',
                            }}
                          >
                            <TableTitle>STATUS</TableTitle>
                          </TableCell>
                          <TableCell
                            align="left"
                            //   padding={headCell.disablePadding ? 'none' : 'normal'}
                            //   key={headCell.id}
                            sx={{
                              alignSelf: 'center',
                              height: '48px',
                            }}
                          >
                            <TableTitle sx={{ marginLeft: '30px' }}>
                              PERMISSÃO
                            </TableTitle>
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {usersListFiltered.map((row, index) => {
                          const labelId = `enhanced-table-checkbox-${index}`;

                          return (
                            <TableRow
                              hover
                              // onClick={event =>
                              //   handleClick(event, row.name as string)
                              // }
                              tabIndex={-1}
                              key={row?.name}
                            >
                              <TableCell
                                id={labelId}
                                scope="row"
                                padding="normal"
                                align="center"
                                onClick={() =>
                                  navigate(`detalhes-usuario/${row?.id}`)
                                }
                                sx={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  height: '50px',
                                  gap: '15px',
                                  padding: '0',
                                  marginLeft: '10px',
                                }}
                              >
                                {row?.avatar_url ? (
                                  <Avatar
                                    alt="Remy Sharp"
                                    sx={{
                                      width: '32px',
                                      height: '32px',
                                      padding: '0',
                                      margin: '0',
                                    }}
                                  >
                                    <img
                                      src={row?.avatar_url as string}
                                      alt="Foto de perfil"
                                      style={{ width: '100%' }}
                                    />
                                  </Avatar>
                                ) : (
                                  <Avatar
                                    {...stringAvatar(row?.name as string)}
                                    sx={{
                                      width: '32px',
                                      height: '32px',
                                      padding: '0',
                                      margin: '0',
                                      fontSize: '14px',
                                    }}
                                  />
                                )}
                                {splitName(row?.name as string, 'firstName')}
                              </TableCell>
                              <TableCell
                                align="left"
                                onClick={() =>
                                  navigate(`detalhes-usuario/${row?.id}`)
                                }
                                sx={{
                                  height: '50px',
                                  padding: '0',
                                }}
                              >
                                {splitName(row?.name as string, 'lastName')}
                              </TableCell>
                              <TableCell
                                scope="row"
                                align="left"
                                onClick={() =>
                                  navigate(`detalhes-usuario/${row?.id}`)
                                }
                                sx={{
                                  height: '50px',
                                  padding: '0',
                                }}
                              >
                                {row?.email}
                              </TableCell>
                              <TableCell
                                align="center"
                                sx={{
                                  height: '50px',
                                  padding: '0',
                                }}
                              >
                                {row?.status === 'US1' && (
                                  <strong className="active">Ativo</strong>
                                )}
                                {row?.status === 'US2' && (
                                  <strong className="desactive">
                                    Desativado
                                  </strong>
                                )}
                                {row?.status === 'US3' && (
                                  <strong className="pendent">
                                    <Button
                                      onClick={() =>
                                        handleOpenModal(
                                          row?.id,
                                          row?.email,
                                          row?.name,
                                        )
                                      }
                                      sx={{
                                        width: '114px',
                                        height: '28px',
                                        borderRadius: '50px',
                                        padding: '4px 12px',
                                        textTransform: 'none',
                                        color: '#ffffff',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '5px',
                                        fontWeight: '400',
                                        fontSize: '14px',
                                      }}
                                    >
                                      Pendente
                                      <Refresh
                                        sx={{
                                          color: '#ffffff',
                                          width: '20px',
                                          height: '20px',
                                        }}
                                      />
                                    </Button>
                                  </strong>
                                )}
                              </TableCell>
                              <TableCell
                                onClick={() =>
                                  navigate(`detalhes-usuario/${row?.id}`)
                                }
                                sx={{
                                  height: '50px',
                                  padding: '0',
                                }}
                              >
                                {(row?.profile === 'UN1' ||
                                  row?.profile === 'UN2') && (
                                  <Div
                                    sx={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'space-between',
                                      width: '90px',
                                      marginLeft: '50px',
                                    }}
                                  >
                                    Admin
                                  </Div>
                                )}
                                {row?.profile === 'UN3' && (
                                  <Div
                                    sx={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'space-between',
                                      width: '90px',
                                      marginLeft: '50px',
                                    }}
                                  >
                                    Membro
                                  </Div>
                                )}
                                {row?.profile === 'UN4' && (
                                  <Div
                                    sx={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'space-between',
                                      width: '90px',
                                      marginLeft: '50px',
                                    }}
                                  >
                                    Convidado
                                  </Div>
                                )}
                              </TableCell>
                              {/* <TableCell
                     align="center"
                     sx={{
                       height: '50px',
                       padding: '0',
                     }}
                   >
                     <Button
                       onClick={() => handleEditUser(row, index)}
                       >
                       <EditOutlined />
                       </Button>
                      </TableCell> */}
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                ) : (
                  <Box
                    sx={{
                      width: '100%',
                      marginTop: '50px',
                      height: '40vh',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    <InfoCard title="Nenhum usuário encontrado!" type="info" />
                  </Box>
                )}
                <TablePagination
                  backIconButtonProps={{ disabled: page === 0 }}
                  nextIconButtonProps={{ disabled: page >= totalPages - 1 }}
                  rowsPerPageOptions={[5, 10, 25]}
                  component="div"
                  count={listagemUsuarios.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  labelRowsPerPage="Linhas por página"
                  onPageChange={handleChangePage}
                  labelDisplayedRows={defaultLabelDisplayedRows}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </Paper>
            </div>
          </Page>
        )}
      </React.Fragment>
      <Dialog
        sx={{
          '& .MuiDialog-container': {
            '& .MuiPaper-root': {
              width: '100%',
              maxWidth: '33.75rem', // Set your width here
              display: 'flex',
              alignItems: 'center',
              height: '310px',
            },
          },
        }}
        className="modal"
        open={recoverPassword}
        keepMounted
        onClose={handleCloseRecoverPassword}
        aria-describedby="alert-dialog-slide-description"
      >
        <Div sx={{ marginTop: '20px' }}>
          <section className="alert-validation">
            <img src={alert} alt="alert-icon" />
          </section>
        </Div>
        <DialogTitle>
          <Div
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <h3>Tem certeza que deseja redefinir sua senha?</h3>
            <p>A ação não pode ser desfeita.</p>
          </Div>
        </DialogTitle>
        <DialogContent>
          <Div sx={{ display: 'flex', flexDirection: 'row', gap: '20px' }}>
            <Button
              color="error"
              variant="outlined"
              className="btn-confirm"
              onClick={handleCloseRecoverPassword}
              sx={{ height: '40px' }}
            >
              Cancelar
            </Button>
            <Button
              color="error"
              variant="contained"
              className="btn-confirm"
              onClick={handleCloseRecoverPassword}
            >
              Sim
            </Button>
          </Div>
        </DialogContent>
      </Dialog>
      <Dialog
        sx={{
          '& .MuiDialog-container': {
            '& .MuiPaper-root': {
              width: '100%',
              maxWidth: '35.75rem', // Set your width here
              display: 'flex',
              alignItems: 'center',
              height: '310px',
            },
          },
        }}
        className="modal"
        open={desactiveMember}
        keepMounted
        onClose={handleCloseMemberDesactive}
        aria-describedby="alert-dialog-slide-description"
      >
        <Div sx={{ marginTop: '20px' }}>
          <section className="alert-validation">
            <img src={alert} alt="alert-icon" />
          </section>
        </Div>
        <DialogTitle>
          <Div
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <h3>Tem certeza que deseja desativar um membro?</h3>
            <p>A ação não pode ser desfeita.</p>
          </Div>
        </DialogTitle>
        <DialogContent>
          <Div sx={{ display: 'flex', flexDirection: 'row', gap: '20px' }}>
            <Button
              color="error"
              variant="outlined"
              className="btn-confirm"
              onClick={handleCloseMemberDesactive}
              sx={{ height: '40px' }}
            >
              Cancelar
            </Button>
            <Button
              color="error"
              variant="contained"
              className="btn-confirm"
              onClick={handleCloseMemberDesactive}
            >
              Sim
            </Button>
          </Div>
        </DialogContent>
      </Dialog>
      <Dialog open={openModalToResendInvite} keepMounted>
        <Box padding="20px">
          <DialogTitle sx={{ padding: '0px' }}>
            Reenviar notificação
          </DialogTitle>
          <DialogContent sx={{ padding: '0px', margin: '15px 0px' }}>
            <TextModal>
              Deseja realmente reenviar uma notificação de cadastro pendente
              para este usuário?
            </TextModal>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="flex-start"
              width="100%"
              marginTop="16px"
            >
              <Button
                variant="outlined"
                endIcon={<ContentCopyRounded color="success" />}
                color="success"
                type="button"
                onClick={contentCopy}
              >
                Copiar convite
              </Button>
            </Box>
          </DialogContent>
          <DialogActions sx={{ padding: '0px' }}>
            {!loadingReInvite && (
              <Button
                onClick={() => setOpenModalToResendInvite(false)}
                sx={{
                  color: '#9E9E9E',
                  fontWeight: '500',
                  fontSize: '14px',
                }}
              >
                Cancelar
              </Button>
            )}
            <Button
              onClick={handleReInvite}
              variant="contained"
              color="success"
              sx={{ color: '#ffffff' }}
              disabled={loadingReInvite}
              endIcon={
                loadingReInvite && (
                  <CircularProgress color="primary" size="16px" />
                )
              }
            >
              {loadingReInvite ? 'Carregando...' : 'Confirmar'}
            </Button>
          </DialogActions>
        </Box>
      </Dialog>
      <Dialog
        open={openModalToSuccessInvite}
        onClose={() => setOpenModalToSuccessInvite(false)}
        keepMounted
      >
        <Box
          padding="20px"
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          gap="20px"
        >
          <DialogTitle
            sx={{
              padding: '0px',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '5px',
            }}
          >
            <CheckCircleOutlineRounded
              sx={{ color: '#4caf50', width: '70px', height: '70px' }}
            />
            <TitleModal>Notificação reenviada com sucesso!</TitleModal>
          </DialogTitle>
          <DialogContent sx={{ padding: '0px', margin: '10px 0px' }}>
            <TextModalSuccess>
              {userData.name} receberá uma notificação para ativar seu cadastro
              no e-mail
              <strong> {userData.email}</strong>
            </TextModalSuccess>
          </DialogContent>
          <DialogActions sx={{ padding: '0px' }}>
            <Button
              onClick={() => setOpenModalToSuccessInvite(false)}
              variant="outlined"
              sx={{
                color: '#323232',
                fontWeight: '500',
                fontSize: '15px',
                borderColor: '#323232',
              }}
            >
              Fechar
            </Button>
          </DialogActions>
        </Box>
      </Dialog>
    </Container>
  );
}
